<template>
  <div>
    <el-card body-style="padding: 0">
      <div slot="header" class="clearfix">
        <span style="color: #409EFF">我的业务员</span>
      </div>
      <el-form ref="queryForm" :model="queryForm" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="用户名" prop="saleman">
              <el-input v-model="queryForm.saleman" placeholder="请输入用户名"/>
            </el-form-item>
          </el-col>
          <el-col :span="8" :offset="6">
            <el-form-item>
              <el-button type="primary" size="small"
                         @click="submitQueryForm()" icon="el-icon-search">
                查询
              </el-button>
              <el-button type="primary" size="small" plain
                         @click="resetQueryForm()" icon="el-icon-refresh">
                重置
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card>
      <el-button type="primary" size="small" style="margin: 0 0 10px 20px"
                 icon="el-icon-plus" @click="handleAdd('添加业务员')">添加业务员
      </el-button>
      <el-table :data="tableData"
                ref="table"
                border default-expand-all stripe
                :max-height="tableHeight"
                :header-cell-style="{'text-align':'center'}"
                style="width: 100%;margin-bottom: 20px;"
                :cell-style="{'text-align':'center'}">
        <el-table-column prop="salemanId" label="用户ID">
          <template slot-scope="scope">
            <span style="text-align: center">{{ getStrEndWithNumbers(scope.row.salemanId) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="salemanName" label="用户名"/>
        <el-table-column prop="upSalemanName" label="上级业务员"/>
        <el-table-column prop="commissionMoneyRate" label="抽佣比例" width="120">
          <template slot-scope="scope">
            <span v-html="scope.row.commissionMoneyRate"></span>
          </template>
        </el-table-column>
        <el-table-column prop="money" label="金额"/>
        <el-table-column prop="businessNums" label="商家数"/>
        <el-table-column prop="shopNums" label="店铺数"/>
        <el-table-column prop="addDateTime" label="添加时间"/>
        <el-table-column prop="statusStr" label="状态"/>
        <el-table-column prop="remarks" label="备注"/>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="text"
                       @click="handleBackEdit(scope.$index, scope.row,'添加备注')">
              备注
            </el-button>
            <el-button size="mini" type="text"
                       @click="handleRateEdit(scope.$index, scope.row,'设置抽佣比例')">
              抽佣比例设置
            </el-button>
            <el-button size="mini" type="text"
                       @click="handleAssignPrice(scope.$index, scope.row)">
              指定定价
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          :page-sizes="[20, 50, 100, 200]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="pagination.pageNum"
          :page-size="pagination.pageSize"
          :total="pagination.total"
          @size-change="handlePageSizeChange"
          @current-change="handlePageNumChange"
          background
          style="float: right;margin-bottom: 10px">
      </el-pagination>
    </el-card>

    <el-dialog :title="dialogTitle"
               :visible.sync="dialogFormVisible"
               :before-close="beforeDialogClose">
      <el-form ref="dialogForm" :model="dialogForm" :rules="rules" label-width="160px" label-position="right" style="margin: 5%">
        <el-form-item label="用户名：" prop="salemanName">
          <el-input v-model="dialogForm.salemanName" placeholder="用户名"></el-input>
          <div style="color: red;">请使用手机号作为用户名</div>
        </el-form-item>
        <el-form-item label="商家抽佣比例：">
          <el-input v-model="dialogForm.businessRecommendRate" placeholder="商家抽佣比例"></el-input>
          <span style="color: red">商家抽佣比例（小于100）%</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submitDialogForm()" size="mini" type="primary">提交</el-button>
        <el-button @click="handleCloseDialog" size="mini">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="dialogBackTitle" :visible.sync="dialogBackFormVisible">
      <el-form ref="dialogBackForm" :model="dialogBackForm" label-width="230px">
        <el-form-item label="备注">
          <el-input v-model="dialogBackForm.remarks" style="width: 50%;"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submitBackDialogForm()" size="mini" type="primary">提交</el-button>
        <el-button @click="handleBackCloseDialog" size="mini">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="dialogRateTitle" :visible.sync="dialogRateFormVisible">
      <el-form ref="dialogRateForm" :model="dialogRateForm" label-width="220px">
        <el-form-item label="商家业务抽佣">
          <el-input v-model="dialogRateForm.businessCommission" style="width: 30%;" size="mini"></el-input>
          <span>%<span style="margin-left:1%; color: red">(注：商家订单完成后，给予业务员的点数)</span></span>
        </el-form-item>
        <el-form-item label="试客业务抽佣">
          <el-input v-model="dialogRateForm.customerCommission" style="width: 30%;" size="mini"></el-input>
          <span>%<span style="margin-left:1%; color: red">(注：试客订单完成后，给予业务员的点数)</span></span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submitRateDialogForm()" size="mini" type="primary">提交</el-button>
        <el-button @click="handleRateCloseDialog" size="mini">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {addSaleman, addSalemanRemarks, querySaleman} from "../../api/b2cbusiness/b2c_saleman";
import {getStrEndWithNumbers} from "../../lib/utils";
import MixinCUD from "../../components/MixinCUD";
import MinxinScroll from "@/components/MinxinScroll";
import {setCommission} from "@/api/b2cbusiness/storelist";

export default {
  name: "MySaleman",
  mixins: [MixinCUD, MinxinScroll],
  data() {
    return {
      tableData: [],
      rules:{
        salemanName: [{
          pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
          required: true,
          message: "请输入正确的手机号码",
          trigger: "blur"
        }],
      },
      queryFormRefName:"queryForm",
      queryForm: {
        saleman: ''
      },
      dialogFormVisible: false,
      dialogTitle: "",
      dialogRefName: "dialogForm",
      dialogForm: {},
      dialogBackFormVisible: false,
      dialogBackTitle: "",
      dialogBackRefName: "dialogBackForm",
      dialogBackForm: {},
      dialogRateFormVisible: false,
      dialogRateTitle: "",
      dialogRateRefName: "dialogRateForm",
      dialogRateForm: {},
      tableHeight: 450,
      pagination: {
        pageNum: 1,
        pageSize: 20,
        total: null
      },
    }
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 320;
    //console.log(document.body.clientHeight, this.tableHeight)
  },
  mounted() {
    this.getData();
  },
  methods: {
    handleAssignPrice(index, row){
      this.$router.push({path:'/home/addpricesetting', query:{userName:row.salemanName, priceModeType:0, modelId:null}});
    },
    submitBackDialogForm(){
      this.$refs[this.dialogBackRefName].validate((valid) => {
        if (valid) {
          this.$confirm("确定提交数据么?")
              .then(_ => {
                addSalemanRemarks(this.dialogBackForm).then(res=>{
                  if (res.success){
                    this.$message({message: res.data, type: 'success'});
                    this.getData();
                    this.dialogBackFormVisible = false;
                  }
                });
                //取消新增或修改也要重置表单
              }).catch(err => {this.handleCloseDialog();});
        } else {
          return false;
        }
      });
    },
    submitRateDialogForm(){
      this.$refs[this.dialogRateRefName].validate((valid) => {
        if (valid) {
          this.$confirm("确定提交数据么?")
              .then(_ => {
                this.dialogRateForm.b2cUsersId = this.dialogRateForm.salemanId;
                setCommission(this.dialogRateForm).then(res=>{
                  if (res.success){
                    this.dialogRateFormVisible = false;
                    this.$message.success("更新数据成功！");
                    this.getData();
                  }
                }).catch(err => {
                  this.$message({message: err.message, type: 'error'});
                });
                //取消新增或修改也要重置表单
              }).catch(err => {this.handleCloseDialog();});
        } else {
          return false;
        }
      });
    },
    handleBackEdit(index, row,dialogTitle) {
      this.dialogBackFormVisible = true;
      this.dialogBackTitle = dialogTitle
      this.resetBackDialogForm()
      this.dialogBackForm = {...row}
    },
    handleRateEdit(index, row,dialogTitle) {
      this.dialogRateFormVisible = true;
      this.dialogRateTitle = dialogTitle
      this.resetRateDialogForm()
      this.dialogRateForm = {...row}
    },
    resetRateDialogForm(){
      for(let item in this.dialogRateForm){
        if (typeof this.dialogRateForm[item]==='string'){
          this.dialogRateForm[item]='';
        } else if (this.dialogRateForm[item] instanceof Array) {
          this.dialogRateForm[item]=[];
        } else{
          this.dialogRateForm[item]=null
        }
      }
    },
    resetBackDialogForm(){
      for(let item in this.dialogBackForm){
        if (typeof this.dialogBackForm[item]==='string'){
          this.dialogBackForm[item]='';
        } else if (this.dialogBackForm[item] instanceof Array) {
          this.dialogBackForm[item]=[];
        } else{
          this.dialogBackForm[item]=null
        }
      }
    },
    handleBackCloseDialog(){
      this.$refs[this.dialogBackRefName].resetFields();
      this.dialogBackFormVisible = false;
    },
    handleRateCloseDialog(){
      this.$refs[this.dialogRateRefName].resetFields();
      this.dialogRateFormVisible = false;
    },
    getStrEndWithNumbers(numbers) {
      return getStrEndWithNumbers(numbers, 8);
    },
    getData() {
      querySaleman(this.queryForm, this.pagination).then(res => {
        console.log(res.data)
        if (res.success) {
          this.tableData = res.data.records;
          console.log(this.tableData)
          this.pagination.pageNum = res.data.current;
          this.pagination.pageSize = res.data.size;
          this.pagination.total = res.data.total;
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      })
    },
    addData(){
      this.dialogForm.roleCode = "salesman";
      if (this.dialogForm.businessRecommendRate > 100){
        this.$message.error("抽佣比例不能大于100%");
      }else{
        addSaleman(this.dialogForm).then(res=>{
          if (res.success){
            this.$message({message: res.data, type: 'success'});
            this.getData();
            this.dialogFormVisible = false;
          }
        }).catch(err => {
          this.$message({message: err.message, type: 'error'});
          this.handleCloseDialog();
        });
      }
    },
    handlePageSizeChange(val) {
      this.pagination.pageSize = val;
      this.submitQueryForm()
    },
    handlePageNumChange(val) {
      this.pagination.pageNum = val;
      this.submitQueryForm()
      //切换页面恢复到顶部
      this.scrollTop = 0
      this.saveScroll()
    },
  }
}
</script>

<style lang="scss" scoped>
.el-form {
  margin-top: 20px;
}
</style>
